<et-step-layout [data]="data">
  <div class="flex align-items-center justify-content-between">
    <div class="w-9">
      <p class="title3Font mt-0"
         i18n>Supplementary materials</p>
      <p class="body2Font"
         i18n>Additional materials from your paper</p>
    </div>
    @if (!isReadonly) {
      <div class="flex">
        <p-button (onClick)="addLink()"
                  label="Add link"
                  i18n-label
                  styleClass="p-button-outlined">
        </p-button>
        <p-button (onClick)="addFile()"
                  label="Add file"
                  i18n-label
                  class="ml-3"
                  styleClass="p-button-outlined">
        </p-button>
      </div>
    }
  </div>

  <div>
    @if (tableSettings) {
      <p-table [scTableSettings]="tableSettings">
        @if (!isReadonly; as rowData) {
          <ng-template pTemplate="row-actions"
                       let-rowData>
            <p-button styleClass="p-button-rounded p-button-text"
                      icon="fas fa-trash"
                      (onClick)="onDeleteSupplement(rowData)"
                      pTooltip="Click to delete supplement"
                      tooltipPosition="top"
                      i18n-pTooltip>
            </p-button>
          </ng-template>
        }
      </p-table>
    }
  </div>
</et-step-layout>